import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
const apiURL = `${baseURL}/grt-user-center-service`;

export const getNoticeList = async (data) => {
    return hMacAjax.post(apiURL + '/user-project-bulletin/v1/page', data);
};

export const getNoticeDesc = async (noticeId) => {
    return hMacAjax.get(apiURL + `/user-project-bulletin/v1/${noticeId}`);
};

export const getNoticeRead = async (noticeId) => {
    return hMacAjax.post(apiURL + '/user-project-bulletin/v1/read', {id: noticeId});
};

export const getNoticeForceRead = async (business_id) => {
    return hMacAjax.get(apiURL + '/user-project-bulletin/v1/force/read', business_id);
};